import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Checkbox, Field } from "@conserveit/blocks";
import { connect } from "react-redux";
import DynamicFormComponent from "./DynamicFormComponent";

@connect(
  (state) => ({
    isFormDisabled: state.reportGenerator.isFormDisabled,
  }),
  null,
  null,
  { forwardRef: true }
)
export default class CondenseCheckBox extends DynamicFormComponent {
  static propTypes = {
    isFormDisabled: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = { condense: false };
  }

  handleCondenseChange = (e) => {
    this.setState({ condense: !this.state.condense });
    // To be updated when blocks are updated
    // this.setState({ condense: e.currentTarget.checked })
  };

  validate = () => true;

  getSelectedValues = () => {
    return { condense: this.state.condense };
  };

  render() {
    return (
      <Field label="Condense" name="jira_issue">
        {({ name }) => (
          <Checkbox
            label="Only include flagged Jira issues."
            name={name}
            checked={this.state.condense}
            disabled={this.props.isFormDisabled}
            onChange={this.handleCondenseChange}
          />
        )}
      </Field>
    );
  }
}
